import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {push} from 'react-router-redux';
import {createSelector} from 'reselect';
import {Checkbox} from 'rmwc';
import * as styles from '../../styles';
import {request} from '../../containers/actions';
import Mark from '../marker/mark';
import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {refresh as paginatorRefresh, clearSelection} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';


export default class Answers extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    style = {items: {itemsList: {width: 'auto', minWidth: '100%', overflowX: 'auto'}}}

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {
            field: item => _.map(
                item.examination.grades,
                grade => grade.title,
            ).join(window.gettext(',') + ' ') + ' - ' + item.examination.title,
            label: window.gettext('Examination'),
        },
        {field: item => (item.index + 1).persian(), label: window.gettext('Question Index')},
        {field: item => `${item.student.firstname} ${item.student.lastname}`, label: window.gettext('Name')},
        {field: item => (item.student.national_id || '').persian(), label: window.gettext('National ID')},
        {field: item => item.priority ? item.priority.persian() : '-', label: window.gettext('Priority')},
        {
            field: item => <div
                title={_.map(
                    item.results,
                    result => `${result.marker.firstname} ${result.marker.lastname} - ` +
                    `${result.timestamp.toJalali().persian('YYYY/MM/DD - HH:MM:SS')} - ` +
                    `${result.time_spent.persian()} ${window.gettext('Seconds')}`,
                ).join('\x0a') + '\x0a' + '_'.repeat(50) + '\x0a' + _.map(
                        item.ignored_by,
                        marker => `\x0a${marker.firstname} ${marker.lastname}`,
                    )}
                style={{
                    backgroundColor: item.results.length > 0
                        ? styles.successBackColor
                        : item.unreadable ? styles.alertBackColor : item.ignored_by.length > 0
                            ? styles.warningBackColor : undefined,
                    color: item.results.length > 0
                        ? styles.successColor
                        : item.unreadable ? styles.alertColor : item.ignored_by.length > 0
                            ? styles.warningColor : undefined,
                    borderColor: item.results.length > 0
                        ? styles.successBorderColor
                        : item.unreadable ? styles.alertBorderColor : item.ignored_by.length > 0
                            ? styles.warningBorderColor : undefined,
                    textAlign: 'center',
                }}>
                {item.results.length > 0
                    ? item.results.length.persian()
                    : item.unreadable ? window.gettext('Unreadable') : item.ignored_by.length.persian()}
            </div>,
            label: window.gettext('Marks Count'),
        },
        {field: item => item.student.grade ? item.student.grade.title : '-', label: window.gettext('Grade')},
        {field: item => item.student.school ? item.student.school.name : '-', label: window.gettext('School')},
        {field: item => item.student.city ? item.student.city.name : '-' , label: window.gettext('City')},
        {field: item => item.student.city ? item.student.city.region_display : '-', label: window.gettext('Region')},
    ]

    filtersSelector = createSelector.bind(this)(
        [
            () => {
                let statuses = this.props.location.query.status || [];
                if (!(statuses instanceof Array))
                    statuses = [statuses];
                return _.map(statuses, status => Number.parseInt(status));
            },
            () => {
                let indexes = this.props.location.query.index || [];
                if (!(indexes instanceof Array))
                    indexes = [indexes];
                return  _.map(indexes, index => Number.parseInt(index));
            },
            () => this.props.store.get('regionsTreeFilter'),
            () => this.props.store.get('citiesTreeFilter'),
            () => this.props.store.get('schoolsTreeFilter'),
            () => this.props.store.get('gradesTreeFilter'),
            () => this.props.store.get('examinationsGradesTreeFilter'),
            () => this.props.store.get('examinationsTreeFilter'),
        ],
        (statuses, indexes) => [
            {
                field: 'status',
                label: window.gettext('Status'),
                component: <div>
                    {_.map(
                        Array(4),
                        (__, index) => <div
                            style={{
                                display: 'block',
                                float: 'right',
                                width: '10em',
                                cursor: 'pointer',
                            }}
                            key={index}>
                            <Checkbox
                                checked={_.includes(statuses, index)}
                                onChange={this.statusChanged.bind(
                                    this,
                                    index,
                                )}>
                                {window.pgettext('answer', 'Status-' + index)}
                            </Checkbox>
                        </div>,
                    )}
                </div>,
                selected: _.mapValues(
                    _.mapKeys(statuses, _.identity),
                    status => window.pgettext('answer', 'Status-' + status),
                ),
                remove: id => this.statusChanged(Number(id)),
            },
            {
                field: 'region',
                label: window.gettext('Region'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('regionsTreeFilter')}
                        readonly
                        header
                        resource='region'
                        itemLabel='name'
                        label={window.gettext('Region')}
                    />
                </div>,
                selected: this.props.store.getIn(['regionsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'region',
                    this.props.store.getIn(['regionsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'city',
                label: window.gettext('City'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('citiesTreeFilter')}
                        readonly
                        header
                        resource='city'
                        itemLabel={city => `${city.region_display} - ${city.name}`}
                        filter={{
                            'region': this.props.store.getIn(['regionsTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('City')}
                    />
                </div>,
                selected: this.props.store.getIn(['citiesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'city',
                    this.props.store.getIn(['citiesTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'school',
                label: window.gettext('School'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('schoolsTreeFilter')}
                        readonly
                        header
                        resource='school'
                        itemLabel={school => `${school.city.name} - ${school.name}`}
                        filter={{
                            'city': this.props.store.getIn(['citiesTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('School')}
                    />
                </div>,
                selected: this.props.store.getIn(['schoolsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'school',
                    this.props.store.getIn(['schoolsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'grade',
                label: window.gettext('Grade'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('gradesTreeFilter')}
                        readonly
                        header
                        resource='grade'
                        label={window.gettext('Grade')}
                    />
                </div>,
                selected: this.props.store.getIn(['gradesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'grade',
                    this.props.store.getIn(['gradesTreeFilter', 'elementId']),
                )),
            },
            {
                label: window.gettext('Examination Grade'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('examinationsGradesTreeFilter')}
                        readonly
                        header
                        resource='grade'
                        label={window.gettext('Examination Grade')}
                    />
                </div>,
                selected: this.props.store.getIn(['examinationsGradesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'grade',
                    this.props.store.getIn(['examinationsGradesTreeFilter', 'elementId']),
                )),
            },
            {
                label: window.gettext('Examination'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('examinationsTreeFilter')}
                        readonly
                        header
                        resource='examination'
                        itemLabel={examination => _.map(
                            examination.grades,
                            grade => grade.title,
                        ).join(window.gettext(',') + ' ') + ' - ' + examination.title}
                        filter={{
                            grades: this.props.store.getIn(['examinationsGradesTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('Examination Grade')}
                    />
                </div>,
                selected: this.props.store.getIn(['examinationsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'examination',
                    this.props.store.getIn(['examinationsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'index',
                label: window.gettext('Question Index'),
                component: <span>
                    {_.map(
                        Array(20),
                        (__, index) => <div
                            style={{
                                display: 'block',
                                float: 'right',
                                width: '10em',
                                cursor: 'pointer',
                            }}
                            key={index}>
                            <Checkbox
                                checked={_.includes(indexes, index)}
                                onChange={this.indexChanged.bind(
                                    this,
                                    index,
                                )}>
                                {(index + 1).persian()}
                            </Checkbox>
                        </div>,
                    )}
                </span>,
                selected: _.mapValues(
                    _.mapKeys(indexes, _.identity),
                    index => (index +1).persian(),
                ),
                remove: id => this.indexChanged(Number(id)),
            },
        ],
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'national_id', label: window.gettext('national id')},
        {name: 'firstname', label: window.gettext('firstname')},
        {name: 'lastname', label: window.gettext('lastname')},
        {name: 'grade', label: window.gettext('Grade')},
        {name: 'school', label: window.gettext('School')},
        {name: 'city', label: window.gettext('City')},
        {name: 'region', label: window.gettext('Region')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size,
        ],
        () => this.props.readonly
            ? this.props.actions
            : this.props.store.getIn(['paginator', 'selected']).size === 0
                ? this.props.actions
                : _.concat(this.props.actions, [
                    {
                        label: window.gettext('Set Priority'),
                        action: () => {
                            let priority = prompt('Enter a priority for selected items:', '');
                            if (priority === null)
                                return;
                            if (priority === '')
                                priority = null;
                            this.context.store.dispatch([
                                request({
                                    path: '/answer/',
                                    body: this.props.store.getIn(['paginator', 'selected']).map((__, id) => ({id, priority})).toArray(),
                                    method: 'PATCH',
                                }),
                                clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                            ]);
                        },
                    },
                ]),
    )

    constructor(props) {
        super(props);
        this.tooltip = this.tooltip.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    tooltip(item) {
        return item.id;
    }

    statusChanged(status, event) {
        if (event)
            event.stopPropagation();
        let statuses = this.props.location.query.status || [];
        if (!(statuses instanceof Array))
            statuses = [statuses];
        statuses = _.map(statuses, status => Number.parseInt(status));
        if (_.includes(statuses, status)) {
            _.remove(statuses, s => s === status);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, status: statuses},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    status: [...statuses, status],
                },
            }));
        }
    }

    indexChanged(index, event) {
        if (event)
            event.stopPropagation();
        let indexes = this.props.location.query.index || [];
        if (!(indexes instanceof Array))
            indexes = [indexes];
        indexes = _.map(indexes, index => Number.parseInt(index));
        if (_.includes(indexes, index)) {
            _.remove(indexes, s => s === index);
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {...this.props.location.query, index: indexes},
            }));
        }
        else {
            this.context.store.dispatch(push({
                ...this.props.location,
                query: {
                    ...this.props.location.query,
                    index: [...indexes, index],
                },
            }));
        }
    }

    render() {
        if (this.props.params.id)
            return <Mark admin answerId={this.props.params.id}/>;
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='answer'
            style={this.style}
            listFields={this.listFields}
            tooltip={this.tooltip}
            title={window.gettext('Answers')}
            selectable
            filters={this.filtersSelector(this.props.store, this.props.location)}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            actions={this.actionsSelector(this.props.store)}
            buttonActions={this.props.buttonActions}
        />;
    }
}
window.pgettext('answer', 'Status-0');
window.pgettext('answer', 'Status-1');
window.pgettext('answer', 'Status-2');
window.pgettext('answer', 'Status-3');
